import type { TFunction } from 'i18next';

/**
 * CRM-03 §5c: how a due moment is written on a row — Today · 14:00,
 * Tomorrow · 09:30, or Jul 21 · 11:00. The time always follows a middle dot.
 */
export function dueText(t: TFunction, dueAtIso: string): string {
  const due = new Date(dueAtIso);
  const time = `${String(due.getHours()).padStart(2, '0')}:${String(due.getMinutes()).padStart(2, '0')}`;
  const today = new Date();
  const startOf = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const days = Math.round((startOf(due).getTime() - startOf(today).getTime()) / 86_400_000);
  if (days === 0) return `${t('crm.dueToday')} · ${time}`;
  if (days === 1) return `${t('crm.dueTomorrow')} · ${time}`;
  const iso = `${due.getFullYear()}-${String(due.getMonth() + 1).padStart(2, '0')}-${String(due.getDate()).padStart(2, '0')}`;
  return `${iso} · ${time}`;
}

// `wholeDollars` moved to pipeline-money.ts: it formats an AMOUNT, and every
// amount on this screen now goes through the decimal helpers behind the
// money/no-raw-money-arithmetic fence. This file formats dates.
